import { render, staticRenderFns } from "./ExpandableImage.vue?vue&type=template&id=229b9434&scoped=true&"
import script from "./ExpandableImage.vue?vue&type=script&lang=js&"
export * from "./ExpandableImage.vue?vue&type=script&lang=js&"
import style0 from "./ExpandableImage.vue?vue&type=style&index=0&id=229b9434&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229b9434",
  null
  
)

export default component.exports